<template lang="pug">
  .color-wonder-hero.max-at-tweak
    .top-wrap
      .left.xs-12.md-7
        mr-icon.logo.mb-200m(name="colorwonder-logo" height="1.25em")
        h1.xs-f-xxxgrande.md-f-poster.max-at-tweak.bold.cw-color-11.mb-25m.big-title {{ mainTitle }}
        .xs-f-small.max-at-tweak.mb-200m.cw-color-11(v-html="subTitle")
        .ctas.xs-f-xxsmall
          a.mr-btn.btn-round.mr-100m(:href="mainCta.url" @click.prevent="trackMREventAndRedirect('Colorwonder hero - shop now clicked', mainCta.url)") {{ mainCta.text }}
          a.mr-btn.btn-secondary.btn-round(:href="otherCta.url" @click.prevent="trackMREventAndRedirect('Colorwonder hero - virtual try one clicked', otherCta.url)") {{otherCta.text}}
      .divider.xs-1.xs-hide.sm-hide
        .bar
      .right.xs-hide.sm-hide.xs-5
        Bullets(:items="bullets")
    .carousel-wrap
      .carousel.xs-hide.sm-hide.md-hide
        .carousel-track(:style="{'--count': kits.length}")
          template(v-for="kit in moreKits" :key="kit.name")
            KitCard(:kit="kit")
      slick.lg-hide(v-bind="carouselOptions")
        template(v-for="kit in kits" :key="kit.name")
          KitCard(:kit="kit")

    .bottom-wrap.md-hide.lg-hide.mt-200m.xs-pl-100m.xs-pr-100m.md-pl-200m.md-pr-200m.mb-200m
      Bullets(:items="bullets")

</template>
<script>
  import Bullets from './Bullets';
  import KitCard from './KitCard';

  export default {
    name: "ColorWonderHero",

    components: {
      Bullets,
      KitCard,
    },

    props: {
      topTitle: {
        type: String,
        default: ''
      },
      mainTitle: {
        type: String,
        default: ''
      },
      subTitle: {
        type: String,
        default: ''
      },
      mainCta: {
        type: Object,
        default: () => ({})
      },
      otherCta: {
        type: Object,
        default: () => ({})
      },
      bullets: {
        type: Array,
        default: () => ([])
      },
      kits: {
        type: Array,
        default: () => ([])
      }
    },

    computed: {

      moreKits() {
        return [...this.kits, ...this.kits];
      },

      carouselOptions() {
        return {
          slidesToShow: 1,
          centerMode: true,
          infinite: true,
          slidesToScroll: 1,
          cssEase: 'linear',
          // variableWidth: true,
          // speed: 6000,
          autoplay: true,
          // autoplaySpeed: 1000,
          dots: false,
          arrows: false,
          lazyLoad: 'progressive',
          swipeToSlide: true,
          responsive: [
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1
              }
            },
            {
              breakpoint: 960,
              settings: {
                slidesToShow: 2
              }
            }
          ]
        };
      }
    },

  };
</script>
<style scoped lang="stylus">
  .color-wonder-hero
    max-width 1300px
    margin 0 auto
    letter-spacing -0.02em

    .top-wrap
      display flex
      padding 2em
      height fit-content
      justify-content space-between
      .left
        display flex
        flex-direction column
        align-items flex-start
        max-width 540px
        .logo
          color cta-color-4
        .big-title
          font-weight 900
          line-height 0.85em
          font-size 72px
          @media mq-tablet-less
            font-size 48px
        .ctas
          .mr-btn
            text-transform none
            font-weight bold
      .divider
        position relative
        display flex
        justify-content center
        align-items center
        .bar
          width 1px
          background-color ui-color-5
          height 70%
      .right
        display flex
        align-items center
    .carousel-wrap
      .carousel
        position relative
        overflow hidden
        width 100%
        .carousel-track
          animation scroll 45s linear infinite
          display flex
          width fit-content
          &:hover
            animation-play-state paused
          @media mq-tablet-less
            animation scroll-mobile 45s linear infinite


  @keyframes scroll
    0%
      transform translateX(0)
    100%
      transform translateX(calc(-382px * var(--count)))

  @keyframes scroll-mobile
    0%
      transform translateX(0)
    100%
      transform translateX(calc(-60vw * var(--count)))


</style>